import { Checkbox, Col, Divider, Row, Table, Tooltip } from 'antd';
import React, { FC } from 'react';
import { checkIsLoading } from '../../lib/utils/checkLoadingStatus';
import { useAppSelector } from '../../store/hooks';
import { OnRow, Scroll } from './interfaces';
import { RolesPermissionsTableRecord } from '../../lib/interfaces/Roles';

interface IProps {
  dataSource: RolesPermissionsTableRecord[];
  scroll: Scroll;
  onRow: OnRow;
  ckeckAll: (checked: boolean) => void;
}

export const AllPermissionsNewRoleTable: FC<IProps> = ({ dataSource, scroll, onRow, ckeckAll }) => {
  const { permissionsLoading } = useAppSelector((state) => state.roles);

  const renderCheckAll = () => {
    const checked = dataSource.length > 0 && dataSource.every(({ checked }) => checked);
    return (
      <Tooltip title="Выбрать все">
        <Checkbox onChange={(e) => ckeckAll(e.target.checked)} checked={checked} />
      </Tooltip>
    );
  };

  const columns = [
    {
      title: renderCheckAll,
      key: 'checked',
      dataIndex: 'checked',
      render: (checked: boolean) => <Checkbox checked={checked} />,
      width: '26px',
    },
    {
      title: (
        <Row style={{ justifyContent: 'space-between', marginRight: 2, zIndex: 1 }}>
          <Col>{dataSource.length || 0} элем.</Col>
          <Col style={{ cursor: 'pointer', zIndex: 1 }} onClick={() => ckeckAll(true)}>
            Выбрать всё
          </Col>
        </Row>
      ),
      key: 'dsc',
      dataIndex: 'dsc',
      width: '100%',
    },
  ];

  return (
    <div className="create-roles-permissions-new-role">
      <h4 className="text-bold font-size-18 mb2">Все привилегии</h4>
      <Divider className="thin-divider mt0 mb0" />
      <Table
        size="small"
        loading={checkIsLoading(permissionsLoading)}
        columns={columns}
        dataSource={dataSource}
        className="striped-table"
        rowClassName={(r, i) => (i % 2 ? 'cursor-pointer' : 'cursor-pointer striped-table__oddRow')}
        pagination={false}
        onRow={onRow}
        scroll={scroll}
      />
    </div>
  );
};
